<script setup>

import Avatar from "primevue/avatar";
import Button from "primevue/button";
import {onMounted} from "vue";

const props = defineProps({
    canContinueToReservation: Boolean,
    theme: Object,
    forms: Object,
    roundness: Object
})
const selectedService = defineModel('selectedService')
const selectedWorker = defineModel('selectedWorker')

const form = defineModel('form');
</script>

<template>
    <section id="service-picker" class="p-4 duration-700 transform-gpu transition-all" :class="[
        selectedService ? 'h-full ' : ''
    ]">
        <!-- Introductory Text -->
        <div class="mb-6">

            <!-- Vyberte službu -->
            <h2 class="text-xl font-bold text-gray-800 dark:text-gray-100 mt-4">{{ $t('widget.select_service') }}</h2>

            <!-- Vyberte službu, kterou potřebujete... -->
            <p class="text-gray-600 dark:text-gray-200">{{ $t('widget.select_service_description') }}</p>
        </div>

        <!-- Service Grid -->
        <div class="grid md:grid-cols-3 gap-4">
            <div
                v-for="service in forms.reservation_services"
                @click="() => {
                    if (selectedService === service) {
                        selectedService = null; } else {
                            selectedService = service;
                    }
                            selectedWorker = null;
                        }"
                :class="[roundness,
                        'border transition-all shadow-md flex flex-col gap-2 p-3 cursor-pointer transform hover:scale-105 hover:shadow-lg',
                        selectedService === service
                         ? `ring-2 ring-${theme.color}-500 bg-${theme.color}-100 dark:bg-neutral-800 dark:border-neutral-700`
                         : 'bg-white hover:bg-neutral-50 dark:bg-neutral-800 dark:border-neutral-700 dark:hover:bg-neutral-700']">
                <!-- Banner Image -->
                <div class="mb-2 rounded-t-lg -m-3 overflow-hidden h-24 flex justify-center items-center bg-neutral-100 dark:bg-neutral-900">
                    <img v-if="service.image" :src="service.image" alt="" class="w-full object-cover h-24">
                    <span v-else class="pi pi-camera !text-2xl opacity-50"></span>
                </div>

                <!-- Service Name -->
                <p class="text-sm font-semibold text-gray-700 dark:text-white">
                    {{ service.name }}
                </p>
                <!-- Service Name -->
                <p class="text-sm grow text-gray-700 dark:text-white">
                    {{ service.description }}
                </p>

                <div class="flex items-center gap-2">
                    <!-- Service Price -->
                    <div
                        v-if="service.currency"
                        class="text-gray-500 dark:text-gray-100 font-medium text-sm whitespace-nowrap">
                        {{
                            !!service.max_price
                                ? new Intl.NumberFormat('cs-CZ', {
                                style: 'currency',
                                maximumFractionDigits: 0,
                                currency: service.currency
                            }).format(service.min_price) + ' až ' + new Intl.NumberFormat('cs-CZ', {
                                style: 'currency',
                                maximumFractionDigits: 0,
                                currency: service.currency
                            }).format(service.max_price)
                                : new Intl.NumberFormat('cs-CZ', {
                                    style: 'currency',
                                    maximumFractionDigits: 0,
                                    currency: service.currency
                                }).format(service.price)
                        }}
                    </div>

                    <span>-</span>

                    <!-- Service Length in minutes -->
                    <div class="text-gray-500 dark:text-gray-100 font-medium text-sm whitespace-nowrap">
                        {{ service.length_in_minutes }} min
                    </div>
                </div>
            </div>
        </div>

        <div v-if="form.errors.id_services" id="timeslot-error" class="text-red-500 !pt-2 text-sm">{{form.errors.id_services}}</div>
    </section>
</template>

<style scoped lang="scss">

</style>
